import type { Stripe } from '@stripe/stripe-js';

const stripePromises = new Map<string, Promise<Stripe | null>>();

export const getStripe = (stripePublishableKey: string | undefined) => {
  if (!stripePublishableKey) {
    return null;
  }

  const existingPromise = stripePromises.get(stripePublishableKey);

  if (existingPromise) {
    return existingPromise;
  }

  const stripePromise = import('@stripe/stripe-js').then(({ loadStripe }) =>
    loadStripe(stripePublishableKey, {
      developerTools: { assistant: { enabled: false } }
    })
  );

  stripePromises.set(stripePublishableKey, stripePromise);

  return stripePromise;
};
